<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-cubes mr-2" />Shopping Cart</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="No. Request">
                        <b-form-input v-model="filter.noRequest" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Customer">
                        <multiselect v-model="filter.customer"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optCustomer"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Office">
                        <multiselect v-model="filter.office"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optOffice"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3">
                    <b-form-group label="Tgl. Request Dari">
                        <b-form-input type="date" v-model="filter.startDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Tgl. Request Sampai">
                        <b-form-input type="date" v-model="filter.endDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="carts"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="my-3"
            >
                <template v-slot:empty>
                    Tidak ada data inventory.
                </template>
                <template v-slot:cell(requestNo)="row">
                    {{ row.item.no_request }}
                    <div class="small">
                        {{ $helper.parseDate(row.item.created_at) }}, {{ $helper.parseHourMinute(row.item.created_at) }}<br>
                        {{ row.item.name }}
                    </div>
                </template>
                <template v-slot:cell(customer)="row">
                    <strong>{{ row.item.customer_name }}</strong>
                    <div class="small">
                        Toko: {{ row.item.customer_shop_name }}<br />
                        Telp: {{ row.item.customer_phone }}
                    </div>
                </template>
                <template v-slot:cell(total)="row">
                    Rp. {{ $helper.formatThousand(row.item.total) }}
                </template>
                <template v-slot:cell(action)="row">
                    <router-link :to="'shopping-cart/' + row.item.id">
                        <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail Shopping Cart">
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
    </div>
</template>

<script>
import lodash from 'lodash'

export default {
    components: {
    },
    data() {
        return {

            initStatus: 0,
            isBusy: false,
            isSubmitting: false,

            carts: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            fields: [
                { key: "requestNo", label: "Nomor Request", sortable: true },
                { key: "customer", label: "Data Customer", sortable: true },
                { key: "total", label: "Total Harga", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            filter: {
                noRequest: "",
                customer: null,
                office: null,
                startDate: "",
                endDate: ""
            },

            optFilterStatus: [
                { value: -1, text: "Semua" },
                { value: 1, text: "New" },
                { value: 2, text: "Approved" },
                { value: 3, text: "Rejected" },
                // { value: 0, text: "Void" }
            ],
            optCustomer: [],
            optOffice: [],


        }
    },

    watch: {

    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getCustomers = this.$axios.get("catalog-customer/selection").then(res => {
                this.optCustomer = res.data.data
            })
            
            let getOffices = this.$axios.get("master/offices").then(res => {
                this.optOffice = res.data.data
            })

            Promise.all([getItems, getCustomers, getOffices]).then(res => {
                this.initStatus = 1
            })
            .catch(error => this.initStatus = -1)

        },

        getItems(page = 1) {

            this.isBusy = true
            this.carts = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.noRequest)) {
                param += "&filterNoRequest=" + this.filter.noRequest
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(this.filter.customer != null) {
                param += "&filterCustomer=" + this.filter.customer.id
            }

            if(this.filter.office != null) {
                param += "&filterOffice=" + this.filter.office.id
            }

            if(!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if(!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("shopping-cart" + param).then(res => {
                console.log(res.data.data)

                this.carts = res.data.data.items
                this.totalRows = res.data.data.total
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        parseStatus(status, index) {
            switch(status) {
                case 1: return ["warning", "NEW"][index]
                case 2: return ["success", "APPROVED"][index]
                case 3: return ["danger", "REJECTED"][index]
                default: return ["light", "-"][index]
            }
        },
           

    },
    computed: {

    },
    created() {
        this.init()
    }
}
</script>